<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.permissions_add">新增</el-button>
            </el-col>

            <el-col class="main-content">
                <el-table :data="dataList" border v-loading="loading" style="width: 100%"
                  row-key="id"
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                    <!-- <el-table-column prop="id" label="ID" width="80"></el-table-column> -->

                    <el-table-column prop="name" label="权限名称" width="280"></el-table-column>
                    <el-table-column prop="route" label="权限路由" width="280"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.permissions_add">编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.permissions_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="dialogClose" width="550px" :close-on-click-modal="false" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="上级权限"
                    :label-width="formLabelWidth"
                    prop="pid"
                    :rules="[
                    { required: true, message: '请选择上级权限', trigger: 'blur' }
                    ]">
                    <el-select v-model="form.pid" placeholder="请选择上级权限">
                        <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="(item.pid != 0 ? '--' : '') + item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权限名称"
                    :label-width="formLabelWidth"
                    prop="name"
                    :rules="[
                    { required: true, message: '请输入权限名称', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.name" autocomplete="off" placeholder="如: 用户列表"></el-input>
                </el-form-item>
                <el-form-item label="权限路由"
                    :label-width="formLabelWidth"
                    prop="route"
                    :rules="[
                    { required: true, message: '请输入权限路由', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.route" autocomplete="off" placeholder="如: user/index"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {PermissionsIndex, PermissionsAdd, PermissionsDel} from "@/utils/request.js"
    import {mapState} from 'vuex'

    export default {
        data(){
            return {
                data: {
                    page: 1
                },
                loading: false,
                dataList: [],
                options: [],
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增权限",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    pid: "",
                    name: "",
                    route: "",
                }
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(['power']),
        methods: {
            refreshData() {
                this.data.page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                PermissionsIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.options = res.data.options
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        PermissionsAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    pid: data.pid,
                    name: data.name,
                    route: data.route,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑权限" : "新增权限"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    pid: "",
                    name: "",
                    route: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增权限"
            },
            del(id, row) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    PermissionsDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            }
        }
    }
</script>

<style>
</style>
